module.exports = require("react-syntax-highlighter/dist/esm/languages/prism");